module.exports = __webpack_public_path__ + "media/images/icons/gazelle-icons-08e257dcf349d6120db89ce2fe1a6515.svg";